import React, { useEffect, useState } from 'react';
import { ConfirmDialog, StandardDialog } from '@roc/ui';
import { FundingTemplate } from './fundingTemplate';
import { useDocumentStore } from '../../../hooks/useDocumentStore';
import { useStore } from '@roc/client-portal-shared/hooks';
import { Document } from '@roc/feature-types';
import { CustomTaskDialog } from '@roc/feature-general-tasks';

export type FundingTemplateDialogProps = {
  open?: boolean;
  onClose?: () => void;
  document: Document;
};

export const FundingTemplateDialog = (props: FundingTemplateDialogProps) => {
  const { open, onClose, document } = props;
  const taskId = document?.taskId;
  const [showDialog, setShowDialog] = useState(false);
  const [showDialogNportal, setShowDialogNportal] = useState(false);
  const { documentStore } = useDocumentStore();
  const { globalStore } = useStore();

  useEffect(() => {
    if (globalStore.isInternalPortal && !documentStore.isInsuranceApprovalAccepted) {
      setShowDialog(true);
    } else {
      handleConfirmDialog();
    }
  }, [open]);

  const handleConfirmDialog = () => {
    setShowDialog(false);
    setShowDialogNportal(true);
  };

  const handleClose = () => {
    setShowDialog(false)
    setShowDialogNportal(false)
    onClose()
  };

  return (
    <>
      {taskId ? (
        <CustomTaskDialog
          open={!globalStore.isInternalPortal ? open : (open && showDialogNportal)}
          title="Funding Template"
          maxWidth="xl"
          handleClose={handleClose}
          dialogContent={<FundingTemplate />}
          taskId={taskId}
        />
      ) : (
        <StandardDialog
          open={!globalStore.isInternalPortal ? open : (open && showDialogNportal)}
          title="Funding Template"
          maxWidth="xl"
          handleClose={handleClose}
          dialogContent={<FundingTemplate />}
        />
      )}
      <ConfirmDialog
        open={open && showDialog}
        confirmButtonText={'Yes'}
        handleClose={handleClose}
        handleCancel={handleClose}
        handleConfirm={handleConfirmDialog}
        title={'Warning'}
        body={`Insurance Approval Document is not accepted yet. Hence insurance amount is considered as 0. Do you still want to continue?`}
      />
    </>

  );
};

export default FundingTemplateDialog;
